import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useRevShare } from '../../../hooks';
import { useCurrentModule } from '../../ModuleProvider';
import { RevShareSectionHelper } from '../RevShareSectionHelper/RevShareSectionHelper';
export const RevShareCollapsibleCycleWrapper = _ref => {
  let {
    cycle,
    children,
    shouldRenderChildren,
    sectionHelperProps
  } = _ref;
  const module = useCurrentModule();
  const {
    isLoading: isRevShareLoading,
    getRevShareAmountPerCycle
  } = useRevShare();
  const formatPrice = module.SDK.useFormatPrice();
  if (shouldRenderChildren) {
    return children;
  }
  if (isRevShareLoading) {
    return null;
  }
  const revShareAmount = getRevShareAmountPerCycle(cycle);
  if (revShareAmount > 0) {
    const formattedAmount = formatPrice(revShareAmount);
    return /*#__PURE__*/React.createElement(RevShareSectionHelper, _extends({
      formattedAmount: formattedAmount,
      marginTop: "SP2"
    }, sectionHelperProps));
  }
  return null;
};
//# sourceMappingURL=RevShareCollapsibleCycleWrapper.js.map